import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useState, useEffect } from "react";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import AddressModal from "../../../components/AddressModal";
import AddressGrid from "../../../components/AddressGrid";
import apis from "../../../context/api";

// eslint-disable-next-line react/prop-types
function CustomerEdit({ id, onSuccess, onCancel }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [errors, setErrors] = useState({});
  const [customerData, setCustomerData] = useState({
    id: null,
    name: "",
    email: "",
    gstn: "",
    phone: "",
    storeName: "",
    defaultShipToAddressId: null,
    defaultBillToAddressId: null,
  });
  const [addresses, setAddresses] = useState([]);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const validateFields = () => {
    const newErrors = {};
    if (!customerData.name.trim()) newErrors.name = "Name is required";
    // if (!customerData.email.trim()) newErrors.email = "Email is required";
    if (!customerData.phone.trim()) newErrors.phone = "Phone is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // returns true if no errors
  };
  useEffect(() => {
    if (!id) {
      setCustomerData({
        id: null,
        name: "",
        email: "",
        gstn: "",
        phone: "",
        storeName: "",
        defaultShipToAddressId: null,
        defaultBillToAddressId: null,
      });
      setAddresses([]);
      setLoading(false);
      return;
    }
    apis
      .getCustomerById(id)
      .then((data) => {
        setCustomerData({
          ...data,
          defaultShipToAddressId: data.defaultShipToAddressId || null,
          defaultBillToAddressId: data.defaultBillToAddressId || null,
        });
        setAddresses(data.addresses || []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, [id, onSuccess]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setCustomerData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddressSaved = (newAddress) => {
    setAddresses((prev) => {
      const exists = prev.find((a) => a.id === newAddress.id);
      if (exists) {
        return prev.map((a) => (a.id === newAddress.id ? newAddress : a));
      }
      return [...prev, newAddress];
    });
    setEditingAddress(null);
    setShowAddressModal(false);
  };

  const handleAddressDeleted = (addressId) => {
    setAddresses((prev) => prev.filter((a) => a.id !== addressId));
  };

  const handleEditAddress = (address) => {
    setEditingAddress(address);
    setShowAddressModal(true);
  };

  const handleAddAddressClick = () => {
    setEditingAddress(null);
    setShowAddressModal(true);
  };

  const handleDefaultAddressesChange = ({ defaultShipToAddressId, defaultBillToAddressId }) => {
    setCustomerData((prev) => ({
      ...prev,
      defaultShipToAddressId,
      defaultBillToAddressId,
    }));
  };
  const updateCustomer = () => {
    apis
      .updateCustomerById(id, customerData)
      .then((data) => {
        setLoading(false);
        if (onSuccess) {
          onSuccess(customerData);
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  const createCustomer = () => {
    apis
      .createCustomer(customerData)
      .then((data) => {
        const customerId = data.id || data.customerId || data.customer_id;
        const updatedCustomerData = {
          ...customerData,
          id: customerId,
        };
        setCustomerData(updatedCustomerData);
        setLoading(false);
        if (onSuccess) {
          onSuccess(updatedCustomerData);
        }
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFields()) {
      return;
    }
    if (id) {
      updateCustomer();
    } else {
      createCustomer();
    }
  };
  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };
  return (
    <MDBox pt={6} pb={6}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox p={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Store Name"
                    name="storeName"
                    variant="outlined"
                    value={customerData.storeName}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="GST No"
                    name="gstn"
                    variant="outlined"
                    value={customerData.gstn}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Contact Person Name"
                    name="name"
                    variant="outlined"
                    value={customerData.name}
                    onChange={handleChange}
                    error={!!errors.name}
                    helperText={errors.name}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    label="Email"
                    name="email"
                    variant="outlined"
                    value={customerData.email}
                    onChange={handleChange}
                    // error={!!errors.email}
                    // helperText={errors.email}
                    // FormHelperTextProps={{
                    //   sx: { color: "red" },
                    // }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <MDInput
                    fullWidth
                    type="number"
                    label="Phone"
                    name="phone"
                    variant="outlined"
                    value={customerData.phone}
                    onChange={handleChange}
                    error={!!errors.phone}
                    helperText={errors.phone}
                    FormHelperTextProps={{
                      sx: { color: "red" },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: 4, pt: 3, borderTop: "1px solid #e0e0e0" }}>
                  <MDTypography variant="h6" mb={2}>
                    Addresses
                  </MDTypography>
                  <AddressGrid
                    addresses={addresses}
                    onEdit={handleEditAddress}
                    onDelete={handleAddressDeleted}
                    customerId={customerData.id || id}
                    onAddClick={handleAddAddressClick}
                    defaultShipToAddressId={customerData.defaultShipToAddressId}
                    defaultBillToAddressId={customerData.defaultBillToAddressId}
                    onDefaultsChange={handleDefaultAddressesChange}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="flex-end"
                pt={4}
                spacing={1}
                display="flex"
                flexWrap="nowrap"
              >
                <Grid item pl={2} pr={2} xs="auto">
                  <MDButton variant="gradient" color="warning" onClick={handleCancel}>
                    Cancel
                  </MDButton>
                </Grid>
                <Grid item xs="auto">
                  <MDButton variant="gradient" color="info" onClick={handleSubmit}>
                    Submit
                  </MDButton>
                </Grid>
              </Grid>
              <AddressModal
                open={showAddressModal}
                onClose={() => setShowAddressModal(false)}
                onSave={handleAddressSaved}
                customerId={customerData.id || id}
                address={editingAddress}
              />
              {error && (
                <MDBox mt={2} color="error">
                  <strong>{error}</strong>
                </MDBox>
              )}
            </MDBox>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default CustomerEdit;
